export const PREMIUM_BUTTON_ID = 'owaPremiumBtn_container';
export const REWARDS_BUTTON_ID = 'owaRewardsBtn_container';
export const MY_DAY_BUTTON_ID = 'owaTimePanelBtn_container';
export const NOTIFICATIONS_BUTTON_ID = 'owaActivityFeedButton_container';
export const SETTINGS_BUTTON_ID = 'owaSettingsBtn_container';
export const TEAMS_BUTTON_ID = 'owaTeamsBtn_container';
export const SYNC_BUTTON_ID = 'owaSyncButton_container';
